import styled from "@emotion/styled"
import { Flex, Skeleton } from "src/components"

export const PricingSkeleton = () => (
	<Flex $gap="xl">
		<HalfWidth>
			<Skeleton.List entries={4} />
		</HalfWidth>
		<HalfWidth />
	</Flex>
)

const HalfWidth = styled.div`
	width: 50%;
`
